import { j as o } from "./AccesRecoveryIcon-CUPieIxT.js";
const s = () => /* @__PURE__ */ o.jsxs("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ o.jsx(
    "path",
    {
      d: "M14.454 8.517H6.542a.99.99 0 0 0-.99.989v5.934a.99.99 0 0 0 .99.989h7.912a.99.99 0 0 0 .989-.99V9.507a.99.99 0 0 0-.99-.99Zm-.494 0V7.033a3.461 3.461 0 1 0-6.923 0v1.484",
      stroke: "currentColor"
    }
  ),
  /* @__PURE__ */ o.jsx("path", { d: "M10.498 12.968a.495.495 0 1 0 0-.99.495.495 0 0 0 0 .99Z", stroke: "currentColor" })
] });
export {
  s as L
};
